/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 4th 2022, 2:26:27 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { InstanceLayoutsView } from "service-builder/components/instance-layouts";

export const LayoutsPage = () => (
  <div className="os-service-builder-card">
    <InstanceLayoutsView />
  </div>
);
